import PropTypes from 'prop-types'
import React from 'react'
import BookingDropdown from './BookingDropdown'
import { MenuItem } from 'material-ui'

const FifteenTimeFields = ({ start, end, selectOnChange, startTimes, endTimes, className }) => {
  return (
    <div className={className}>
      <BookingDropdown
        value={start}
        labelText="start"
        onChange={selectOnChange}>
        {startTimes.map(time => (
          <MenuItem
            value={time.format('H:mm')}
            primaryText={time.format('h:mm a')}
            key={time.format('X')}
          />
        ))}
      </BookingDropdown>
      <BookingDropdown value={end} labelText="end" onChange={selectOnChange}>
        {endTimes.map(time => (
          <MenuItem
            value={time.format('H:mm')}
            primaryText={time.format('h:mm a')}
            key={time.format('X')}
          />
        ))}
      </BookingDropdown>
    </div>
  )
}

FifteenTimeFields.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  selectOnChange: PropTypes.func.isRequired,
  startTimes: PropTypes.arrayOf(PropTypes.object).isRequired,
  endTimes: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
}

export default FifteenTimeFields



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/FifteenTimeFields.js